import styled from 'styled-components/macro'

export const Nav = styled.nav`
  background-color: #17171e;
  height: 4.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.2rem;
  top: 0;
  z-index: 999;
  overflow: hidden;
`

export const MobileIcon = styled.div`
  display: none;

  color: white;
  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 80px;
    left: ${({ click }) => (click ? 0 : '-100%')};
    opacity: 1;
    transition: all 0.5s ease;
    background: #08080b;
  }
`

export const NavItem = styled.li`
  /* height: 80px; */
  border-bottom: 2px solid transparent;
  &:hover {
    border-bottom: 2px solid #4b59f7;
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    &:hover {
      border: none;
    }
  }
`

export const NavLinks = styled.a`
  font-family: 'Lexend Exa', sans-serif;
  color: white;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 3rem;
  height: 100%;
  &:hover {
    color: whitesmoke;
    transition: all 0.3s ease;
  }
  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
  }
`
